export default [
  {
    path: "/emba",
    name:
      "实战EMBA|光华共创会和香港光华管理学院联合发起，旨在培养专业的老板， 做中国最落地、最接地气的实战EMBA总裁班！",
    component: () => import("@/views/co-creation-club/emba.vue"),
    meta: {
      title: "实战EMBA"
    }
  },
  {
    path: "/academy",
    name: "大思维书院|终身学习|轻辅导|微咨询|核心资源",
    component: () => import("@/views/co-creation-club/academy.vue"),
    meta: {
      title: "大思维书院"
    }
  },
  {
    path: "/ivy",
    name:
      "常青藤|接班人|新商业领袖|企业传承|第二增长曲线|传统转型|代际对话|专属活动|国际视野",
    component: () => import("@/views/co-creation-club/ivy.vue"),
    meta: {
      title: "常青藤"
    }
  }
];
